export default __webpack_public_path__ + "static/media/breifcase.c6b97daf.png";